import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs';
import { retry, catchError, take } from 'rxjs/operators';
import { AppConfig } from '../config/app-config';
import { FileSection, FileType, FileData } from './../models/fileData';
import { PayGateInitModel, PayGateResponseInitModel } from '../models/payGate';
import { map } from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class TenderService {

  TenderDisclaimer$: any = {
    'disclaimer': ''
  }
  constructor(private http: HttpClient, private appConfig: AppConfig) {
  }

  //tender releases methods
  public getTenderCategoriesList() {
    let url = this.appConfig.apiUrl + '/TenderCategories/List/1';

    const reqHeaders = this.buildHeaders();

    return this.http.get<any[]>(url, { headers: reqHeaders }).pipe(
      retry(1),
      catchError(this.errorHandler)
    );
  }
  public getTenderDisclaimer() {
    let url = this.appConfig.apiUrl + '/TenderDisclaimer/1';
    const reqHeaders = this.buildHeaders();
    return this.http.get<any[]>(url, { headers: reqHeaders }).pipe(
      take(1),
      retry(1),
      catchError(this.errorHandler)
    );
  }

  public getTenderLocationsList() {
    let url = this.appConfig.apiUrl + '/TenderLocations/List/1';

    const reqHeaders = this.buildHeaders();

    return this.http.get<any[]>(url, { headers: reqHeaders }).pipe(
      retry(1),
      catchError(this.errorHandler)
    );
  }

  public getTenderList(current: boolean) {

    let url = '';

    if (current == true) {
      url = this.appConfig.apiUrl + '/Tender/List/1/0';
    }
    else {
      url = this.appConfig.apiUrl + '/Tender/List/1/1';
    }
    console.log(url);
    const reqHeaders = this.buildHeaders();

    return this.http.get<any[]>(url, { headers: reqHeaders }).pipe(
      retry(1),
      catchError(this.errorHandler)
    );
  }

  public getTenderArticle(tenderId): Observable<any> {
    let url = this.appConfig.apiUrl + '/Tender/' + tenderId;

    var reqHeaders = this.buildHeaders();

    return this.http.get(url, { headers: reqHeaders });
  }

  public getFileInfo<FileData>(linkedId: number) {

    let url = this.appConfig.apiUrl + '/File/' + FileSection.Tender + '/' + FileType.Document + '/' + linkedId;

    var reqHeaders = this.buildHeaders();

    return this.http.get<any[]>(url, { headers: reqHeaders });
  }

  public downloadFile(fileLocation: string) {
    return this.http.get(fileLocation, { responseType: 'blob', observe: 'response' }).pipe(
      retry(1),
      catchError(this.errorHandler)
    );
  }

  public getFilesList(tenderId: number) {
    let url = this.appConfig.apiUrl + '/File/7/2/' + tenderId;

    const reqHeaders = this.buildHeaders();

    return this.http.get(url, { headers: reqHeaders }).pipe(
      retry(1),
      catchError(this.errorHandler)
    );
  }

  //public initTenderPayment(tenderId: number) {
  //  let url = this.appConfig.apiUrl + '/File/7/2/' + tenderId;

  //  const reqHeaders = this.buildHeaders();

  //  return this.http.get(url, { headers: reqHeaders }).pipe(
  //    retry(1),
  //    catchError(this.errorHandler)
  //  );
  //}

  public initTenderPayment(initData) {

    let url = this.appConfig.apiUrl + '/Tender/InitPayment';

    const reqHeaders = this.buildHeaders();

    return this.http.put<PayGateResponseInitModel>(url, initData, { headers: reqHeaders }).pipe(
      retry(1),
      catchError(this.errorHandler)
    );

  }

  buildHeaders() {
    return new HttpHeaders({
      "Access-Control-Allow-Origin": "*",
      "content-type": "application/json; charset=utf-8"
    });
  }

  errorHandler(error) {
    console.log('service: errorHandler called');
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log('service: error! ' + errorMessage);
    return throwError(errorMessage);
  }
}
